import { render } from "./TileDisplay.vue?vue&type=template&id=2c7f7e22&ts=true"
import script from "./TileDisplay.vue?vue&type=script&lang=ts"
export * from "./TileDisplay.vue?vue&type=script&lang=ts"

import "./TileDisplay.vue?vue&type=style&index=0&id=2c7f7e22&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__